// Histórico exibe no máximo uma quebra de linha por vez: sequências de
// quebras (com linhas só de espaços/tabs entre elas) viram um único \n.
// Só para exibição; o valor salvo continua cru (AGROS-3495).
export function collapseLineBreaks(text?: string | null): string {
  if (!text) return '';
  return text.replace(/\r\n?/g, '\n').replace(/\n(?:[ \t]*\n)+/g, '\n');
}
